import { render, staticRenderFns } from "./Library.vue?vue&type=template&id=3c4e65a3"
import script from "./Library.vue?vue&type=script&lang=js"
export * from "./Library.vue?vue&type=script&lang=js"
import style0 from "./Library.vue?vue&type=style&index=0&id=3c4e65a3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports